<template>
      <el-select v-model="companySelected"
                 class="select-transparent-noborder company"
                 @change="changeCompany()">
        <el-option v-if="companies.length != 1" :value="0" label="All Companies" :key="0"/>
        <el-option v-for="company in companies"
                    :value="company.id"
                    :label="company.profile.companyName"
                    :key="company.id"/>
      </el-select>
</template>

<script>
export default {
  name: 'Company-Selector',
  computed: {
    companies () {
      return this.$store.getters.companies.filter(c => !c.archived)
    },
    companySelected: {
      get () { return this.$store.getters.companySelected || (this.companies.length > 1 ? 0 : this.companies[0]) },
      set (companyId) { this.$store.commit('SET_COMPANY_SELECTED', companyId) }
    }
  },
  methods: {
    changeCompany () {}
  }
}
</script>

<style>
.select-transparent-noborder.company {
  width: 170px;
}
</style>